import { render, staticRenderFns } from "./EventReservation.vue?vue&type=template&id=007b6f0c&scoped=true"
import script from "./EventReservation.vue?vue&type=script&lang=js"
export * from "./EventReservation.vue?vue&type=script&lang=js"
import style0 from "./EventReservation.vue?vue&type=style&index=0&id=007b6f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b6f0c",
  null
  
)

export default component.exports